type State = {
	receiveEmail: boolean;
	receivePhoneMessages: boolean;
};

type Action = { type: 'TOGGLE_CONTACT'; field: string } | { type: 'REPLACE_STATE'; state: State };

export const communicationPreferenceInitialState: State = {
	receiveEmail: false,
	receivePhoneMessages: false,
};

export const communicationPreferencesReducer = (state: State, action: Action) => {
	switch (action.type) {
		case 'TOGGLE_CONTACT':
			return {
				...state,
				[action.field]: !state[action.field as keyof State],
			};
		case 'REPLACE_STATE':
			return action.state;
		default:
			return state;
	}
};
